const STORAGE_KEYS = {
  token: 'token',
  customerId: 'clienteId',
  customerName: 'clienteNome',
  customerCnpj: 'clienteCnpj',
};

function safeStorage() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function getStorageItem(key) {
  const storage = safeStorage();
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function decodeJwt(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(Array.from(decoded).map(c => '%'+('00'+c.charCodeAt(0).toString(16)).slice(-2)).join('')));
  } catch {
    return null;
  }
}

function setStorageItem(key, value) {
  const storage = safeStorage();
  if (!storage) return;
  try {
    if (value === null || value === undefined) {
      storage.removeItem(key);
    } else {
      storage.setItem(key, String(value));
    }
  } catch {
    // Ignore storage failures in private browsing or blocked storage
  }
}

function removeStorageItem(key) {
  const storage = safeStorage();
  if (!storage) return;
  try {
    storage.removeItem(key);
  } catch {
    // Ignore removal failures
  }
}

export function saveAuthSession({ token, customerId, customerName, customerCnpj }) {
  setStorageItem(STORAGE_KEYS.token, token);
  setStorageItem(STORAGE_KEYS.customerId, customerId);
  setStorageItem(STORAGE_KEYS.customerName, customerName);
  setStorageItem(STORAGE_KEYS.customerCnpj, customerCnpj);
}

export function getAuthSession() {
  const token = getStorageItem(STORAGE_KEYS.token);
  const storedCnpj = getStorageItem(STORAGE_KEYS.customerCnpj);
  const decoded = decodeJwt(token);
  const jwtCnpj = decoded && decoded.documento ? decoded.documento : null;

  return {
    token: token,
    customerId: getStorageItem(STORAGE_KEYS.customerId),
    customerName: getStorageItem(STORAGE_KEYS.customerName),
    customerCnpj: storedCnpj || jwtCnpj,
  };
}

export function clearAuthSession() {
  removeStorageItem(STORAGE_KEYS.token);
  removeStorageItem(STORAGE_KEYS.customerId);
  removeStorageItem(STORAGE_KEYS.customerName);
  removeStorageItem(STORAGE_KEYS.customerCnpj);
}
